import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const duplicateSurveyStatusSelector = (state: State) =>
  state.duplicateSurvey.status;
export const duplicateSurveySelector = (state: State) =>
  state.duplicateSurvey.entities;
export const duplicateSurveyLoadedSelector = isLoaded(
  duplicateSurveyStatusSelector,
);
export const shouldLoadedDuplicateSurveysSelector = shouldLoad(
  duplicateSurveyStatusSelector,
);
export const duplicateSurveyRejectedSelector = isRejected(
  duplicateSurveyStatusSelector,
);
export const duplicateSurveyPendingSelector = isPending(
  duplicateSurveyStatusSelector,
);
